export default __webpack_public_path__ + "static/media/Cvjetko.5629694e.png";